// document.querySelector('[data-drawer="drawer-cart"]').dispatchEvent(
// new CustomEvent('theme:drawer:open', {
// bubbles: false,
// })
// );

  // Declare a global variable to store the price of "extended-warranty"
// let extendedWarrantyPrice = null;
// alert(extendedWarrantyPrice);
// let warranty_price = document.querySelector('#bundly__details .warranty-price');
// $(document).ready(function() {
//   alert("1")
//     // Fetch the cart data
//     fetch('/cart.js')
//         .then(response => response.json())
//         .then(data => {
//             console.log(data.items);  // Logs all the items in the cart
            
//             // Loop through cart items and check for "extended-warranty"
//             data.items.forEach(item => {
//                 console.log("item_handle:", item.handle);
//                 console.log("item_price:", item.price);

//                 // If the handle matches "extended-warranty", store the price
//                 if (item.handle === "extended-warranty") {
//                     extendedWarrantyPrice = item.price;
//                     alert(extendedWarrantyPrice);
//                     console.log("Extended Warranty Price:", extendedWarrantyPrice);
//                     warranty_price.innerHTML = extendedWarrantyPrice;
//                     alert(warranty_price.innerHTML);
//                 }
//             });

//             // You can use the extendedWarrantyPrice here if needed.
//         })
//         .catch(error => console.error('Error fetching cart:', error));
// });
// document.addEventListener('DOMContentLoaded', function() {
//   const warrantyCheckbox = document.querySelector('.drawer__content .warranty-checkbox');
//    console.log(`prop value is now drawer: ${warrantyCheckbox.getAttribute('prop')}`); 
// });


function cartSubtotal(){
   $.ajax({
        type: 'GET',
        url: '/pages/contact-us',
        dataType: 'html',
        success: function(data){
          // run the calculator with a target price of $75
                  
         var subData =  $(data).find(".cart-sub_total").html();
          $(".cart__drawer .drawer__bottom .cart-sub_total").html(subData);
          
          var totalQty = $(data).find(".cart__drawer__title .cart_total").text();
           $(".cart__drawer__title .cart_total").text(totalQty);
          
          var counter = $(data).find(".header__desktop__button  .cart-counter").text();
           $(".header__desktop__button  .cart-counter").text(counter);
            $(".header__desktop__button  .cart-counter").attr("data-header-cart-count",counter);
          
          // var add_warranty =  $(data).find(".add-warranty-cart").html();
          // console.log(add_warranty);
          // $(".cart__drawer .drawer__bottom .add-warranty-cart").html(add_warranty);
          setTimeout(function(){
           var PriceUpdate = $(".cart__items__row.care_product .cart__items__price span.money").text();
           $(".wrapper-text-warranty .warranty-price").text(PriceUpdate);
          }, 500);
           //console.log("↓—————— ↓—————— ↓" + cartTotal);
          if($("body").hasClass("template-cart")){
              // console.log($(data).find('.cart__subtotal__value').html());
             $('.cart__template .cart__footer__value').html($(data).find('.cart__subtotal__value').html());
          }

          var s_aving =  $(data).find(".money_save .saved_price").html();
            // console.log("saving");
            // console.log(s_aving);
            $(".money_save .saved_price").html(s_aving);

          var interval = setInterval(updateprice, 1);
          // setTimeout(function(){
            function updateprice(){
              
            
            if (s_aving === '-$0.00' || s_aving === '-<span class="money">$0.00</span>' || s_aving === '-£0.00' || s_aving === '-€0,00' || s_aving === '-$0.0 ') {
               $(".money_save").hide();
              $(".money_save").attr("saving-price", "0");
              // console.log("hide-sav");
            }else{
             $(".money_save").show("show-sav");
              $(".money_save").removeAttr("saving-price");
              // console.log(2);
            }


        if($(".cart-properties").length > 0){
           var tootal = 0;
              var cart_totall = 0;
              $(".cart-properties").each(function(){
                  var f_pricee =$(this).attr("total-lprice");
                  tootal = tootal + parseFloat(f_pricee);
                  // console.log(f_price);
              });
               // console.log("l+tottal"+tootal);
           var currency_symbol = $(".hidden-discount-settings").attr("cart-symbol");
               var currency = $(".cart__subtotal__value").attr("cart-currency");
              if($("body").hasClass("template-cart")){
                var currency = $(".cart-footer-total").attr("cart-currency");
              }
           var cart_currency = $(".cart-footer-total").attr("cart-currency");
              $(".bundle-saving .saved_price").text("-"+currency+tootal.toFixed(2));
              $(".bundle-saving").attr("total",tootal);
             // console.log("bundle_savingsss"+ "-"+currency+tootal.toFixed(2));
               var cart_totall =  $(".cart__subtotal__value").attr("cart-total");
               var cartpage_total =  $(".cart-footer-total").attr("cart-total");
              // console.log("cartpage_total"+ cartpage_total);
               var total_price = cart_totall - tootal;
              var carttotal_price = cartpage_total - tootal;
           // console.log("carttotal_price"+ carttotal_price);
          setTimeout(function(){
          $(".cart__template .cart__footer__value").html("<span class='money'>"+ cart_currency+carttotal_price.toFixed(2)+ currency_symbol+"</span>");
            }, 2000);
              // console.log("total_price"+ total_price);
            $(".cart__subtotal__value").text(currency+total_price.toFixed(2)+ currency_symbol);
             var bundle_discount_price = $('.bundle_total_price').attr("compare_discount");
          if(bundle_discount_price != undefined){
            $(".cart__subtotal__value").text(bundle_discount_price);
          $(".cart__template .cart__footer__value").text(bundle_discount_price);
          }
          
            }else{
              $(".bundle-saving").hide();
            }
              clearInterval(interval);
              }
          // }, 3000);
        }
      });
  
}


function groupVariantsByDiscount(variantArray) {
    var discountGroups = {};

    variantArray.forEach(variant => {
        // Use the discount as the key
        var discount = variant.discount;

        // Initialize the array for this discount if it doesn't exist
        if (!discountGroups[discount]) {
            discountGroups[discount] = [];
        }

        // Add the variant to the appropriate discount group
        discountGroups[discount].push(variant);
    });

    return discountGroups;
}

function updateSmallerBundle(groupedArray,bundle_discount){
   $.each(groupedArray, function(index, update) {
     data = {
        id: update.id,
        properties: { Bundle_discount: bundle_discount } // This should be an object, not a string
    }; 
  
    $.ajax({
        url: '/cart/change.js',
        type: 'POST',
        dataType: 'json',
        data: data,
        async : false,
         success: function(cart) {
            console.log('Cart updated for variant:', update, cart);
          $(".drawer__body [data-cart-loading]").addClass("cart--loading");
          $(".drawer__bottom").addClass("bottom-loading-jtpl");
          setTimeout(function(){
             $(".drawer__body [data-cart-loading]").removeClass("cart--loading");
            $(".drawer__bottom").removeClass("bottom-loading-jtpl");
          }, 2000);
        },
        error: function(xhr, status, error) {
            console.error('Error updating variant:', update, error);
        }
    });
     
   });
   document.documentElement.dispatchEvent(new CustomEvent('theme:cart:reload', {bubbles: true}));
     cartSubtotal();
}
     // Function to check bundles and identify incorrect ones
    function checkBundles(groupedArray, validBundles) {
        let incorrectBundles = [];

        Object.keys(groupedArray).forEach(discount => {
            const items = groupedArray[discount];
            const types = items.map(item => item.type);

            let isBundleValid = false;

            validBundles.forEach(bundle => {
                if (bundle.discount === discount) {
                    const hasAllTypes = bundle.types.every(type => types.includes(type));
                    if (hasAllTypes) {
                        isBundleValid = true;
                    }
                }
            });

            if (!isBundleValid) {
                // If no valid bundle is found, mark it as incorrect
                incorrectBundles.push({ discount, items });
            }
        });

        return incorrectBundles;
    }

 var CameraBagBook = $(".camera-bag-book-discountjtpl").text();
 var CameraBag = $(".camera-bag-discountjtpl").text();
 var CameraBook = $(".camera-book-discountjtpl").text();

function checkBundleProducts(cart){
     var items = cart.items;
     var bundles = 0, cameraExists = 0, bagExists = 0, bookExists = 0;
    var variantArray = [];
    
      for(var xx = 0;xx<items.length ; xx++){
        var properties = items[xx].properties;
        var variant_id = items[xx].id;
       // console.log(properties);
        var key_bundle = 0;
        var discount = 0;
        if(properties){
          $(properties).each(function(value,key){
          // console.log(key.Bundle_discount);
            
          // console.log(key);            
            if (key.Bundle_discount) {
              discount = key.Bundle_discount;
               bundles++;
              key_bundle =1;
             //   var tags = $(".cart__items__row.cart__items-"+variant_id).attr("data-tags");
            }            
          });
        }//properties end
        // console.log(bundles);   
        if(bundles){
            //check if camera + bag + Book exists
              //check if only camera + bag exists
              //check if only camera + book exists   
          
            var tags = $(".cart__items__row.cart__items-"+variant_id).attr("data-tags");
           // console.log(tags);
          if(tags != "" && tags != undefined){            
            if(tags.indexOf("camera")> -1 && key_bundle == '1'){
              cameraExists++;
              variantArray.push({ id: variant_id, discount: discount, type: "camera" });
            }
             if(tags.indexOf("bag")> -1 && key_bundle == '1'){
                bagExists++;
                variantArray.push({ id: variant_id, discount: discount, type: "bag" });
             }
             if(tags.indexOf("book")> -1 && key_bundle == '1'){
               variantArray.push({ id: variant_id, discount: discount, type: "book" });
                bookExists++;
            }
          }
        }//bundles end
      } //forloop ends
    // console.log(cameraExists+"====="+bagExists+"====="+bookExists);
// console.log(cameraArray);
//  console.log(bagArray);
//  console.log(bookArray);
 // console.log(variantArray); 
  //check if camera is greater than qty 2
 var groupedArray = groupVariantsByDiscount(variantArray);
  var discountKeys = Object.keys(groupedArray); // Extract keys from the object
// console.log("Groupedd");
  // console.log(groupedArray);   
  var bundle_discount = 0;
  const validBundles = [
        { types: ["camera", "book"], discount: CameraBook },
        { types: ["camera", "bag"], discount: CameraBag },
        { types: ["camera", "bag", "book"], discount: CameraBagBook}
    ];

   const incorrectBundles = checkBundles(groupedArray, validBundles);
 var removePropArray = [];
    if (incorrectBundles.length > 0) {
        // console.log("Incorrect Bundles:");
        incorrectBundles.forEach(bundle => {
            // console.log(`Discount: ${bundle.discount}`);
            // console.log("Items:", bundle.items);
             if(bundle.discount == CameraBagBook){
               var cam = 0,bag = 0,book =0;
                $.each(groupedArray[CameraBagBook], function(index, update) {
                    var id = update.id;
                    var discount = update.discount;
                    var type = update.type;
                  if(type == "camera"){
                    cam++;
                  }else if(type == "book"){
                    book++;
                  }else if(type == "bag"){
                    bag++;
                  }       
                  
                });
              //  alert(cam+"===="+bag+"====="+book);
                if(cam > 0 && bag > 0){
                  // alert("heree bag");
                  updateSmallerBundle(groupedArray[CameraBagBook],CameraBag);
                }else if(cam > 0 && book > 0){
                //  alert("heree book");
                   updateSmallerBundle(groupedArray[CameraBagBook],CameraBook);
                }else{
                   removePropArray = groupedArray[CameraBagBook];
                }
            }else if(bundle.discount == CameraBag){
              removePropArray = groupedArray[CameraBag];
            }else if(bundle.discount == CameraBook){
              removePropArray = groupedArray[CameraBook];
            }
        });
     
    } 
  
   
    if(cameraExists > 0 && bagExists > 0 && bookExists > 0 && $.inArray(CameraBagBook,discountKeys) > -1 && groupedArray[CameraBagBook].length == 3 ){
      //bundle discount - 20%
     var bundle_discount = CameraBagBook;
     
    }else if($.inArray(CameraBagBook,discountKeys) > -1 && groupedArray[CameraBagBook].length > 0 ){
      bundle_discount = 0;
      var cam = 0,bag = 0,book =0;
      $.each(groupedArray[CameraBagBook], function(index, update) {
          var id = update.id;
          var discount = update.discount;
          var type = update.type;
        if(type == "camera"){
          cam++;
        }else if(type == "book"){
          book++;
        }else if(type == "bag"){
          bag++;
        }       
        
      });
      // console.log(cam+"===="+bag+"====="+book);
      if(cam > 0 && bag > 0){
          updateSmallerBundle(groupedArray[CameraBagBook],CameraBag);
      }else if(cam > 0 && book > 0){
         updateSmallerBundle(groupedArray[CameraBagBook],CameraBook);
      }else{
         removePropArray = groupedArray[CameraBagBook];
      }
     
    } 
  
    if(cameraExists > 0 && bagExists > 0 && $.inArray(CameraBag,discountKeys) > -1 && groupedArray[CameraBag].length == 2){
      //bundle discount - 15%
      var bundle_discount = CameraBag;     
    }else if($.inArray(CameraBag,discountKeys) > -1 && groupedArray[CameraBag].length > 0 ){
      bundle_discount = 0;
      removePropArray = groupedArray[CameraBag];
    } 
  
  if(cameraExists > 0 && bookExists > 0 && $.inArray(CameraBook,discountKeys) > -1 && groupedArray[CameraBook].length == 2){
      //bundle discount - 12%
     var bundle_discount = CameraBook;     
    }else if($.inArray(CameraBook,discountKeys) > -1 && groupedArray[CameraBook].length > 0 ){
      bundle_discount = 0;
      removePropArray = groupedArray[CameraBook];
    } 
  
    // console.log(bundle_discount);
    // console.log(variantArray);
    // console.log(cart);
  cartSubtotal();
  // console.log(removePropArray);
  if(bundle_discount != 0 && removePropArray.length == 0){
     return false;
 
  }
    // Create a data object for the cart update
    var data = {};

// Prepare the data for the AJAX request
$.each(removePropArray, function(index, update) {
  // if(bundle_discount > 0){
  //   data = {
  //       id: update,
  //       properties: { Bundle_discount: bundle_discount } // This should be an object, not a string
  //   };
  // }else{
  // }

    data = {
        id: update.id,
        properties: { Bundle_discount: '' }
    };
  
    $.ajax({
        url: '/cart/change.js',
        type: 'POST',
        dataType: 'json',
        data: data,
      async : false,
        success: function(cart) {
            console.log('Cart updated for variant:', update, cart);
          // console.log($(cart).find('.cart__items__meta').html());
          setTimeout(function(){
          if($(cart).find('.cart__items__meta').html() == undefined){
            $(".bundle-saving").attr("total", 0);
          }
          }, 2000);
          cartSubtotal();
          $(".drawer__body [data-cart-loading]").addClass("cart--loading");
          $(".drawer__bottom").addClass("bottom-loading-jtpl");
          setTimeout(function(){
             $(".drawer__body [data-cart-loading]").removeClass("cart--loading");
            $(".drawer__bottom").removeClass("bottom-loading-jtpl");
          }, 2000);
        },
        error: function(xhr, status, error) {
            console.error('Error updating variant:', update, error);
        }
    });    
});
       document.documentElement.dispatchEvent(new CustomEvent('theme:cart:reload', {bubbles: true}));
     cartSubtotal();
  }

  
$(document).ready(function(){
  if($("body").hasClass("template-collection")){
    setTimeout(function(){
      // console.log("template-collection");
      $(".flickity-slider").css("transform", "translateX(0%)");
       $(".flickity-slider").css("opacity", "1");
      $(".flickity-slider div.slide-item.flickity-cell.is-selected[data-index='1']").css("transform", "translateX(0%)");
    }, 500);
  }
     $('.cart__drawer .money_save.cart-temp').remove();
  
  // var interval = setInterval(updateprice, 10);
            // setTimeout(function(){
            //   function updateprice(){
              
            // if($(".cart-properties").length > 0){
            // var total = 0;
            //       var cart_total = 0;
            //       $(".cart-properties").each(function(){
            //           var f_price =$(this).attr("total-lprice");
            //           total = total + parseFloat(f_price);
            //           // console.log(f_price);
            //       });
            //        console.log("l+tottal"+total);
            //        var currency = $(".cart__subtotal__value").attr("cart-currency");
            //   if($("body").hasClass("template-cart")){
            //     var currency = $(".cart-footer-total").attr("cart-currency");
            //   }
            //   var cart_currency = $(".cart-footer-total").attr("cart-currency");
            //       $(".bundle-saving .saved_price").text("-"+currency+total);
            //       $(".bundle-saving").attr("total",total);
            //       var cart_total =  $(".cart__subtotal__value").attr("cart-total");
            //        var cartpage_total =  $(".cart-footer-total").attr("cart-total");
            //       console.log("cartpage_total"+ cartpage_total);
            //        var total_price = cart_total - total;
            //       var carttotal_price = cartpage_total - total;
            //    console.log("carttotal_price"+ carttotal_price);
            //   setTimeout(function(){
            //   $(".cart__template .cart__footer__value").html("<span class='money'>"+ cart_currency+carttotal_price.toFixed(2)+"</span>");
            //   },2000);
            //       console.log("total_price"+ total_price);
            //     $(".cart__subtotal__value").text(currency+total_price.toFixed(2));
                  
            //  }
            //     clearInterval(interval);
            //   }
  
   if(window.location.href.indexOf('cart_open=true') >-1){
    document.querySelector('.navlink--cart[data-drawer-toggle="drawer-cart"]').click();
    history.pushState({}, "", window.location.href.split('?')[0]);
}
  $(".menu__item.child.main-menu--active").parents(".menu-with-image").addClass("active_menu");
   var cookieValue = getCookie('kidamento_care');
  console.log(cookieValue);
 if(cookieValue == "false"){
    $("input.warranty-checkbox").prop("checked", false);
  }
  if(!getCookie('kidamento_care')){
    $('.warranty-checkbox').prop("checked",false);
    $('.warranty-checkbox').removeAttr('prop').attr('prop', 'false');
    // $('.warranty-checkbox').attr('bydefault', 'false');
     // console.log("cookieValue----");
  }
  // setTimeout(function(){
  //   if($('.warranty-checkbox').length > 0 && $('.warranty-checkbox').prop("checked") == true){
  //    setCookie("kidamento_care", "true", 7); 
  //   }
  // },100);
   
//  document.documentElement.dispatchEvent(new CustomEvent('theme:cart:reload', {bubbles: true}));
  
  document.addEventListener('theme:cart:change', function(event) {
    // alert("hy")
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      // console.log(cart);
      console.log(cart.items);
      var items = cart.items;
      var itemCount = cart.item_count;
      var totalQty = 0;
      for(var i = 0;i<items.length ; i++){
        var quantity = items[i].quantity;
         totalQty = parseInt(totalQty) + parseInt(quantity);
      }
      $(".cart__drawer__title .cart_total").text("("+totalQty+")");
      if(itemCount == 0){
           $(".cart-qualified-message-jtpl").addClass("cart--hidden");
        }
      else{
        $(".cart-qualified-message-jtpl").removeClass("cart--hidden");
      }
    $.ajax({
          type: 'GET',
          url: '/pages/our-story',
          dataType: 'html',
          success: function(data){
            $('.cart__drawer .money_save.cart-temp').remove();
              var saving =  $(data).find(".money_save .saved_price").html();
            // console.log("saving");
            // console.log(saving);
            
            $(".money_save .saved_price").html(saving);
            var interval = setInterval(updateprice, 10);
            // setTimeout(function(){
              function updateprice(){
            if (saving === '-$0.00' || saving === '-<span class="money">$0.00</span>' || saving === '-£0.00' || saving === '-€0,00' || saving === '-$0.0 ') {
               $(".money_save").hide();
              $(".money_save").attr("saving-price", "0");
              // console.log("hide-sav");
            }else{
             $(".money_save").show("show-sav");
              $(".money_save").removeAttr("saving-price");
              // console.log(2);
            }
              
            if($(".cart-properties").length > 0){
            var total = 0;
                  var cart_total = 0;
                  $(".cart-properties").each(function(){
                      var f_price =$(this).attr("total-lprice");
                      total = total + parseFloat(f_price);
                      // console.log(f_price);
                  });
                   // console.log("l+tottal"+total);
               var currency_symbol = $(".hidden-discount-settings").attr("cart-symbol");
                   var currency = $(".cart__subtotal__value").attr("cart-currency");
              if($("body").hasClass("template-cart")){
                var currency = $(".cart-footer-total").attr("cart-currency");
              }
              var cart_currency = $(".cart-footer-total").attr("cart-currency");
                  $(".bundle-saving .saved_price").text("-"+currency+total.toFixed(2));
                  $(".bundle-saving").attr("total",total);
               // console.log("bundle_savingsss"+ "-"+currency+total.toFixed(2));
             
                  var cart_total =  $(".cart__subtotal__value").attr("cart-total");
                   var cartpage_total =  $(".cart-footer-total").attr("cart-total");
                  // console.log("cartpage_total"+ cartpage_total);
                   var total_price = cart_total - total;
                  var carttotal_price = cartpage_total - total;
               // console.log("carttotal_price"+ carttotal_price);
              setTimeout(function(){
              $(".cart__template .cart__footer__value").html("<span class='money'>"+ cart_currency+carttotal_price.toFixed(2)+ currency_symbol+"</span>");
              },2000);
                  // console.log("total_price"+ total_price);
                $(".cart__subtotal__value").text(currency+total_price.toFixed(2)+ currency_symbol);
              setTimeout(function(){
              var bundle_discount_price = $('.bundle_total_price').attr("compare_discount");
                // console.log("bundle_discount_price"+ bundle_discount_price);
                 if(bundle_discount_price != undefined){
                 $(".cart__subtotal__value").text(bundle_discount_price);
                  $(".cart__template .cart__footer__value").text(bundle_discount_price);
                 }
                  },2000);
             }else{
              $(".bundle-saving").hide();
             }
                clearInterval(interval);
              }              
            // },3000);
          }
        });
     /********************** Free shiping progressbar start  ****************************/ 
      function calculateProgress(currentVal, targetVal) {       
        var progressBar = document.querySelectorAll('.cart-shippingThreshold__progress');
        // calculate how far progress is from the total as a percentage
        var result = Math.round(100 * currentVal / targetVal);
        progressBar.forEach(function(el){
          el.setAttribute('style', "width: ".concat(result, "%"));
        })
         // Update the progess text. If threshold is met, show success message
        var newProgressNum = (targetVal - currentVal) / 100;
      };
      var limit = $(".cart__message").attr("data-limit");
       $.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json',
        success: function(cart){
          // run the calculator with a target price of $75
          calculateProgress(cart.total_price, limit+"00"); 
          checkBundleProducts(cart);
        }
      });
    /************************* Free shiping progressbar end  ****************************/ 
    setTimeout(function(){
      var PriceUpdate = $(".cart__items__row.care_product .cart__items__price span.money").text();
           $(".wrapper-text-warranty .warranty-price").text(PriceUpdate);
       }, 500);
      // ... update an app or a custom shipping caluclator
      // setTimeout(function(){
        add_care();
      // },100) ;
    }else{
      if($(".cart__items__row.care_product").length > 0){
           remove_care();
         } 
    }
   
  });

var care_value = [];
var percent_of= '';
var nearest_value = '';
var variant_addto='';
var last_care_value = [];
var seconLastNumber='';  
var  goal='';
var closest ='';
var  round_of ='';
var cart_items = $('.cart__items__row').attr('product_id');
var per_val = $('.per_val').text();
var line__price = $('.cart__items__row[product_id="7434316742734"] .line__price .money').text();
fline__price = line__price.replace('$',''); 
$('.careprice').text('('+line__price+')');

  
  async function add_care(){   
     var cookieValue = getCookie('kidamento_care');
console.log('Value of cookie1:', cookieValue);
      if($('.warranty-checkbox').length > 0 && $('.warranty-checkbox').prop("checked") == true && cookieValue == "true"){
         $.ajax({
        type: 'GET',
          url: '/cart.js',
          dataType: 'json',
          cache: false,
          async: false,
           success: function(cart_response) {
             var items = cart_response['items'];
             var total = 0; 
             var kidamento_care = "0";
            var kidamento_care_id = "0";
             for(var x = 0; x <items.length ; x++){
              var tot = items[x]['final_line_price'];
               console.log("tot"+tot);
               if(items[x]['product_id'] !="7434316742734"){
                 // if(items[x]['discounted_price']){
                   // total = total + parseFloat(items[x]['discounted_price']/100);
                 // }else{
                   total = total + parseFloat(items[x]['final_line_price']/100); 
                 // }
                       
               console.log("total-+-price" + total);
               }else{
                 kidamento_care = "1";   
                 kidamento_care_id = items[x]["id"];
               }
             }
             //var total_price = cart_response['original_total_price'];
             console.log("total--price" + total);
             var total_price =total;
              if($(".bundle-saving").length > 0){
               var bundle_saving = $(".bundle-saving").attr("total");
               console.log("here---"+bundle_saving);
                 total_price = parseFloat(total_price) - parseFloat(bundle_saving);
             }
             var final_price = parseFloat(total_price);
             var percentof = final_price*per_val/100 ;
              percent_of = percentof.toFixed(2);
             console.log("percentofcart=" + percent_of);
            
             
             if(total_price > 0 ){
               $(".care_product option").each(function(){
                    var round_of =  $(this).attr('var_title');
                    care_value.push(round_of);
                });
               
              var goal = percent_of;
              var closest = null;
              $.each(care_value, function(){
                if (closest == null || Math.abs(this - goal) < Math.abs(closest - goal)) {
                  closest = this;
                }
                });


              nearest_value = Number(closest);
              variant_addto = $('.care_product option[var_title="'+nearest_value+'"]').val();
               console.log('nearest_value:'+nearest_value);
             
               var productData = {
                     quantity: 1,
                     id: variant_addto,
                }

               if(kidamento_care == "1"){
                 var oldVariantId = kidamento_care_id ; //$(".cart__items__row.care_product").attr("data-variant_id");
                 // console.log(oldVariantId);
                  $.ajax({
                  url: '/cart/change.js',
                  type: 'POST',
                  dataType: 'json',
                  data: {
                    id: oldVariantId,
                    quantity: 0
                  },
                  cache: false,
                    async : false,
                  success: function() {
                      document.documentElement.dispatchEvent(new CustomEvent('theme:cart:reload', {bubbles: true}));
                    $(".drawer__body [data-cart-loading]").addClass("cart--loading");
                    $(".drawer__bottom").addClass("bottom-loading-jtpl");
                     $.ajax({
                          type: 'POST',
                          url: '/cart/add.js',
                          data:	productData,
                          dataType: 'json',
                          cache: false,
                           async : false,
                         success: function(add_product){                 
                          setTimeout(function(){
                             $(".drawer__body [data-cart-loading]").removeClass("cart--loading");
                            $(".drawer__bottom").removeClass("bottom-loading-jtpl");
                          }, 3000);
                           console.log('added');
                           console.log(add_product);
                           document.documentElement.dispatchEvent(new CustomEvent('theme:cart:reload', {bubbles: true}));
                           cartSubtotal();
                         }
                       }); 
                    },
                    error: function(error) {
                      console.error('Error removing old variant:', error);
                    }
                  });
               }else{
                 $(".drawer__body [data-cart-loading]").addClass("cart--loading");
                 $(".drawer__bottom").addClass("bottom-loading-jtpl");
                  remove_care();
                    $.ajax({
                      type: 'POST',
                      url: '/cart/add.js',
                      data:	productData,
                      dataType: 'json',
                      cache: false,
                       async : false,
                     success: function(add_product){
                     console.log('added');
                      setTimeout(function(){
                         $(".drawer__body [data-cart-loading]").removeClass("cart--loading");
                        $(".drawer__bottom").removeClass("bottom-loading-jtpl");
                      }, 2000);
                       console.log(add_product);
                      setTimeout(function(){
                       var PriceUpdate = $(".cart__items__row.care_product .cart__items__price span.money").text();
                       $(".wrapper-text-warranty .warranty-price").text(PriceUpdate);
                      }, 500);
                       document.documentElement.dispatchEvent(new CustomEvent('theme:cart:reload', {bubbles: true}));
                       cartSubtotal();
                     }
                   });          
               }
            
             }else{
                remove_care();
             }
           }
         });
      }else{
          remove_care();
      }
  }
  
/************************** Add Extended Warranty start  ***********************************/
   $("body").on("click",".custom-checkout-jtpl",function(e){
    e.preventDefault();
    if($(".cart__items__meta .cart-properties").length > 0){
   $.ajax({
        type: 'GET',
        url: '/cart.js',
        cache: false,
        dataType: 'json',
        success: function(cart) {
            // console.log('helo');
           // console.log(cart);
            $.ajax({
    type: "POST",
    url: "/apps/checkout/checkout.php",
    data: { cardata: cart },
    dataType: 'text', // Change this to 'text' instead of 'json'
    success: function(response) {
        // console.log('added-123');
        //alert('helo');
        // window.location.href = response; // response should be a URL
        // console.log(response);
      var cleanedResponse = response.replace(/<!--[\s\S]*?-->/g, "");

        // Step 2: Use regex to find the first URL (http:// or https://)
        var match = cleanedResponse.match(/https?:\/\/[^\s]+/);

        if (match && match[0]) {
            // Step 3: Redirect to the first URL found
          // alert(match[0]);
           window.location.href = match[0];
        } else {
            console.error('No valid URL found in the response.');
        }
    },
    error: function(xhr, status, error) {
        console.log("error");
        console.log(xhr, status, error);
    }
});
   
        }
    });
    }else{
      window.location.href="/checkout";
    }
  });

    const warrantyCheckbox = $(".warranty-checkbox");
  if(!getCookie('kidamento_care')){
    if (warrantyCheckbox.attr('bydefault') === 'true') {
      setCookie("kidamento_care", "true", 7);
      setTimeout(function(){
        $("input.warranty-checkbox").prop("checked", true);
      }, 2000);
      // console.log("cokkie-sett");
    }
    else{
          setCookie("kidamento_care", "false", 7);
      setTimeout(function(){
        $("input.warranty-checkbox").prop("checked", false);
        warrantyCheckbox.removeAttr('prop').attr('prop', 'false');
        // alert(1);
       }, 2000);
      // console.log("cokkie-setf");
    }
  }
  
  $("body").on("change",".warranty-checkbox",function(){
      if ($(this).is(':checked')) {
            $(this).attr('prop', 'true');
            setCookie("kidamento_care", "true", 7); 
        // console.log(true);
        // console.log("cokkie-ckt");
           add_care();
        } else {
          //remove variant care product
            $(this).removeAttr('prop').attr('prop', 'false');
            // console.log(true);
             if($(".cart__items__row.care_product").length > 0){
             remove_care();
             setCookie("kidamento_care", "false", 7);
               // console.log("cokkie-cktf");
           }
          
        }
    });

    // setTimeout(function(){
    // if ($(".warranty-checkbox").attr('bydefault') === 'false'){ 
    //        $(".warranty-checkbox").prop("checked", false);
    //        $(".warranty-checkbox").attr("prop", false);
    //        setCookie("kidamento", "false", 7);
    //         // add_care();
    //        // $(".warranty-checkbox").is(':checked');
    //        console.log("warranty-checkbox==false");
    //  }
    //   else{
    //     if ($(".warranty-checkbox").attr('bydefault') === 'true') { 
    //          $(".warranty-checkbox").prop("checked", true);
    //          $(".warranty-checkbox").attr("prop", true);
    //          setCookie("kidamento_care", "true", 7); 
    //           // add_care();
    //          // $(".warranty-checkbox").is(':checked');
    //          console.log("warranty-checkbox==true");
    //       }  
    //       else{
    //         // deleteCookie("kidamento_care");
    //         console.log("warranty-checkbox==false");
    //       }
    //   }
    // },2000);
  
    $("body").on("click", ".care_product .cart__items__remove", function(){
      $(".warranty-checkbox").trigger("click");
      setCookie("kidamento_care", "false", 7);
  });

   // if ($(".warranty-checkbox").attr('prop') === 'false' && $(".warranty-checkbox").attr('bydefault') === 'false'){ 
   //         $(".warranty-checkbox").prop("checked", false);
   //         $(".warranty-checkbox").attr("prop", false);
   //         setCookie("kidamento_care", "false", 7); 
   //          // add_care();
   //         // $(".warranty-checkbox").is(':checked');
   //         console.log("warranty-checkbox==false");
   //      }
  
 
  function setCookie(name, value, days) {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

// Function to delete a cookie
function deleteCookie(name) {
  document.cookie = name + '=; Max-Age=-99999999; path=/';
}
  
  function getCookie(name) {
  const nameEQ = name + "=";
  const cookies = document.cookie.split(';');
  for(let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i];
    while (cookie.charAt(0) === ' ') cookie = cookie.substring(1, cookie.length);
    if (cookie.indexOf(nameEQ) === 0) return cookie.substring(nameEQ.length, cookie.length);
  }
  return null;
}
  
 async function remove_care(){
    $(".cart__items__row.care_product").each(function(){
       var productId = $(this).attr("data-variant_id");
    // console.log(productId);
      if(productId){        
            $.ajax({            
            type: 'POST',
            url: '/cart/change.js',
            data: {
              id: productId,
              quantity: 0,
            },
            dataType: 'json',
            async : false,
            success: function (data) {
              // console.log(data);
              $(".drawer__body [data-cart-loading]").addClass("cart--loading");
              
               document.documentElement.dispatchEvent(new CustomEvent('theme:cart:reload', {bubbles: true}));
              var PriceUpdate = $(".cart__items__row.care_product .cart__items__price span.money").text();
             $(".wrapper-text-warranty .warranty-price").text("");
               document.documentElement.dispatchEvent(new CustomEvent('theme:cart:reload', {bubbles: true}));
              if($("body").hasClass("template-cart") == false){
                 document.querySelector('[data-drawer="drawer-cart"]').dispatchEvent(
               new CustomEvent('theme:drawer:open', { bubbles: true }) );
                $(".drawer__body [data-cart-loading]").addClass("cart--loading");
                $(".drawer__bottom").addClass("bottom-loading-jtpl");
          setTimeout(function(){
             $(".drawer__body [data-cart-loading]").removeClass("cart--loading");
            $(".drawer__bottom").removeClass("bottom-loading-jtpl");
          }, 2000);
              }
             
               $(".cart__items").html($(data).find('.cart__items').html());  
               cartSubtotal();
            // jQuery.ajax({
            //   url: '/cart',
            //   type: "GET",
            //   dataType: "html",
            //   success: function(data) { 
            //     $(".cart__items").html($(data).find('.cart__items').html());  
            //        }
            //   });
             }
           });
      }
    })
  
    
  }

 

  
  /************************** Add Extended Warranty end  ***********************************/
  //product page
  $('.main_sticky_cart').hide();

if($('body').hasClass("template-product")){
  var reviewInterval = setInterval(reviewIntervalFunc,500);

  function reviewIntervalFunc(){
    // console.log($('.jdgm-prev-badge__text').text());
    var reviewcount=$('.jdgm-prev-badge__text').text().trim();
    var countvalue=reviewcount.split(' ')[0];
    // console.log(countvalue);
    if(countvalue != undefined || countvalue != null || countvalue .length > 0){
       $(".review_tab").append(' ('+ countvalue + ')'); 
       setTimeout(function(){
         $(".jdgm-prev-badge__text").text(countvalue); 
       },1000)  ;
        clearInterval(reviewInterval);
       }
  }
  var check= $('.jdgm-widget-actions-wrapper').html();

//icon position for product image box
   $(".jtpt-txt-1").addClass("active");
  $("body").on("click",".custom_count",function(e){
    e.preventDefault();
    var $this = $(this);
    $(".icon-position").removeClass("active");
    $this.parents(".icon-position").addClass("active");
     var count=$(this).attr('data-conn');
     $(".icon_text").removeClass("active");
     $(count).addClass("active")
     // console.log(count);
  });
}
$("body").on("click", ".icon_text", function(e) {
    e.preventDefault();
    $(".icon_text").removeClass("active");
     var $this = $(this);
      // var $parentIconText = $this.parents(".icon_text");
     $this.addClass("active");
    var iconAttr = $this.attr("data-con");
     $(".icon-wrapper .icon-position").removeClass("active");
      $(".icon-wrapper .icon-position").each(function() {
        var dataConn = $(this).find("span").data("conn");
        if (dataConn === iconAttr) {
            $(this).addClass("active");
        }
    });
});


  // $("body").on("click",".column_video-jtpl .btn--play-jtpl",function(e){
  //   e.preventDefault();
  //   var $this = $(this);
  //   var video = $(this).attr("data-video");
  //   var type = $(this).attr("data-video-type");
  //  // console.log(video+"====="+type);
  //     if(type=="vimeo"){
  //       var video_link = "https://player.vimeo.com/video/"+video+"?autoplay=1";
  //     }else if(type=="youtube"){
  //         var video_link = "https://www.youtube.com/embed/"+video+"?enablejsapi=1&autoplay=1";
  //     }
  //     if(video_link){
  //       var iframe = '<iframe src="'+video_link+'" class="js-'+type+' block" allow="autoplay; encrypted-media" allowfullscreen title=""></iframe>';
  //     //console.log(iframe);
  //       var style= $this.parents(".column_video-jtpl").find("img").parents(".block").attr("style");
  //         $this.parents(".column_video-jtpl").find("img").parents(".block").attr("style","display:none");
  //       $this.parents(".column_video-jtpl").find(".video-iframe-jtpl").removeAttr("style");
  //       $this.parents(".column_video-jtpl").find(".video-iframe-jtpl").attr("style",style);
         
  //          $this.parents(".column_video-jtpl").find(".video-iframe-jtpl").append(iframe);
  //       $this.hide();
  //     }
    
  // });
$("body").on("click", ".column_video-jtpl .btn--play-jtpl", function(e) {
    e.preventDefault();
    var $this = $(this);
    var video = $(this).attr("data-video");
    var type = $(this).attr("data-video-type");
    var video_link;

    // Clean up the video ID for YouTube
    if (type == "youtube") {
        // Extract the video ID from a full YouTube URL if necessary
        var videoIdMatch = video.match(/(?:youtube\.com\/(?:embed\/|v\/|watch\?v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
        if (videoIdMatch) {
            video = videoIdMatch[1]; // Get the actual video ID
        }
        video_link = "https://www.youtube.com/embed/" + video + "?enablejsapi=1&autoplay=1";
    } 
    // Clean up the video ID for Vimeo
    else if (type == "vimeo") {
        // Extract the video ID from a full Vimeo URL if necessary
        var videoIdMatch = video.match(/vimeo\.com\/(\d+)/);
        if (videoIdMatch) {
            video = videoIdMatch[1]; // Get the actual video ID
        }
        video_link = "https://player.vimeo.com/video/" + video + "?autoplay=1";
    } 
    else if (type == "mp4") {
        video_link = video; // Direct MP4 link
    }

    if (video_link) {
        var iframe;
        if (type == "mp4") {
            iframe = '<video class="js-' + type + ' block" controls autoplay><source src="' + video_link + '" type="video/mp4"></video>';
        } else {
            iframe = '<iframe src="' + video_link + '" class="js-' + type + ' block" allow="autoplay; encrypted-media" allowfullscreen title=""></iframe>';
        }

        var style = $this.parents(".column_video-jtpl").find("img").parents(".block").attr("style");
        $this.parents(".column_video-jtpl").find("img").parents(".block").attr("style", "display:none");
        $this.parents(".column_video-jtpl").find(".video-iframe-jtpl").removeAttr("style");
        $this.parents(".column_video-jtpl").find(".video-iframe-jtpl").attr("style", style);
        $this.parents(".column_video-jtpl").find(".video-iframe-jtpl").append(iframe);
        $this.hide();
    }
});






// $("body").on("click",".first_accordion",function(e){
//     $(this).siblings(".accordion_body").slideToggle(500);
//    });
  

  /*******************  Search icon start *******************/
  $(".search-icon-drawer").click(function() {
    $(".search-jtpl").show();
  });
   $(".search__predictive__close__inner").click(function() {
    $(".search__predictive__actions input[type='search']").val('');
    // $(".search-jtpl").hide();
  });




/*******************  Search icon end *******************/
  
  //29 july

//   $(".jdgm-prev-badge__text").click(function(){
// $(this).parents(".product__inner").find("#reviews-tab").addClass("open");
//  $(this).parents(".product__inner").find(".review_content").css("display","block");   
    
// });
    // specification and reviews Tabs Releated js
    $(".kntnt-collapse-content > div > div:last-child").slideUp("slow");

    $(".kntnt-collapse-content > div > div:first-child").click(function (e) {

        e.preventDefault();
        var $tab = $(this).parent();
        var is_single = $tab.parent().hasClass("single");
        $tab.toggleClass("open");
        $tab.children(":last-child").slideToggle("slow");

        if (is_single) {
            $tab.siblings().removeClass("open");
            $tab.siblings().children(":last-child").slideUp("slow");
        }

    });
  //blog related 
    var blog_id=$('.custom_featured_blog').attr('custom_blog_url');
       $('.custom_grid').each(function(index, element) {
    // Inside this function, 'this' refers to each individual '.custom_grid' element
    $(element).find('.custom_grid_item').each(function() {
        var all_blog_id = $(this).attr('all_blog_handle');
        if(blog_id == all_blog_id){
         $(this).remove();
        }
    });
});
   document.addEventListener('theme:scroll', e => {
     var viewportHeight = window.innerHeight;
    if ($(this).scrollTop() > viewportHeight)
     {
       $('.main_sticky_cart').fadeIn();
     }
    else
     {  
     $('.main_sticky_cart').fadeOut();
     }});
//Review Popup 
       $("body").on("click",".more_reviews",function(e){
            document.getElementById("overlay").style.display = "block";
            document.getElementById("popupDialog").style.display = "block";
         $("body").addClass("popup-overlay");
         $("#popupDialog .jdgm-form-wrapper").addClass("overyform-review");
       });
       $("body").on("click","#popupDialog button.popup-close",function(e){
            document.getElementById("overlay").style.display = "none";
            document.getElementById("popupDialog").style.display = "none";
          $("body").removeClass("popup-overlay");
         $("#popupDialog .jdgm-form-wrapper").addClass("overyform-review");
       });
      $("body").on("click","#overlay",function(e){
        $("#popupDialog button.popup-close").trigger("click");   
       });
  //write a review button 
// $("body").on("click","#popupDialog .write_review-jtpl",function(e){
//   e.preventDefault(); 
//   document.querySelector("#popupDialog .jdgm-write-rev-link").click(); return false;
// });
  $("body").on("click","#popupDialog .inner-toogle-jtpl",function(e){
    $(".jdgm-form-wrapper.overyform-review").toggle();
  });
  //review click scroll reviews 
  if(document.querySelectorAll('.custom_div_jtpl .jdgm-widget.jdgm-widget').length > 0){
var badgeLink = document.querySelector('.custom_div_jtpl .jdgm-widget.jdgm-widget');

badgeLink.addEventListener('click', function(event) {
    event.preventDefault();
     var lengty =  $(".reviews_wrapper.open").length;
   // console.log($(".reviews_wrapper.open").length+"====here");
  if(lengty <= 0){
    $(".reviews_wrapper .review_heading").trigger("click");   $(".review_content div.jdgm-widget.jdgm-review-widget").css("display", "block");
   $(".review_content div.jdgm-widget.jdgm-review-widget").removeClass("jdgm-hidden");
  }
    $('html, body').animate({
        scrollTop: $('#reviews-tab').offset().top - 90
    }, 1000); 
});
  } 
 $(".accordion-button-two").click(function(){
    $(".review_content div.jdgm-widget.jdgm-review-widget").css("display", "block");
   $(this).removeClass("accordion-is-open");
   $(".review_content div.jdgm-widget.jdgm-review-widget").removeClass("jdgm-hidden");
   $(this).addClass("accordion-is-open");
});
//Review date 
  var dateTimeJudge = setInterval(rev__timestampFunc, 2000);
 var review_count=0;
  var rating_count=0;
function rev__timestampFunc() {
    if ($('.jdgm-rev__timestamp').length > 0) {
        $('.jdgm-rev__timestamp').each(function() {
            // Get the current date value from data-content attribute
            var originalDate = $(this).attr('data-content').split(' ')[0]; // Extracts '2024-06-12' from '2024-06-12 13:21:28 UTC'
            // Convert the date to Month dd yyyy format
            var dateObj = new Date(originalDate);
            var month = dateObj.toLocaleString('en-us', { month: 'long' });
            var day = dateObj.getDate();
            var year = dateObj.getFullYear();
            // Construct the new date format
            var newDateFormat = month + ' ' + day + ', ' + year;
            // Update the content of the span element
            $(this).html(newDateFormat);
        });
    }
  if ($('.jdgm-rev__header .jdgm-rev__rating').length > 0) {
        $('.jdgm-rev__rating').each(function(index) {
            // Get the current date value from data-content attribute
          if(rating_count == index)
      {
            var originalscore = $(this).attr('data-score');
            $(this).prepend("<span class=customer_rating-count>("+originalscore+")</span>" );
        rating_count++;
      }
         
        });
    
      $('.jdgm-rev__author-wrapper').each(function(index) {
           var customerloc = $(this).find("span.jdgm-rev__location").text();
            $(this).parents(".jdgm-rev__header").find(".jdgm-rev__rating").prepend("<span class=customer-rev__location>"+ customerloc + "</span>" );
        });
    
    }
  if ($('.jdgm-rev__header').length > 0) {
  $('.jdgm-rev__header').each(function (index) {
    if(review_count == index)
      {
var firstelement = $(this).find('.jdgm-rev__rating').prop('outerHTML');
    var sectext = $(this).find('.jdgm-rev__author-wrapper').prop('outerHTML');
    
   $(this).find('.jdgm-rev__author-wrapper').remove();
      $(this).find('.jdgm-rev__rating').remove();
    
    var secondElement =  $(this).find('.jdgm-rev__buyer-badge-wrapper');
    var secondelement1 = $(this).find('.jdgm-rev__icon');
    
    
   secondelement1.after(sectext);
    secondElement.after(firstelement);
    var verifybadge = $(this).find('.jdgm-rev__buyer-badge-wrapper').prop('outerHTML');
    $(this).find('.jdgm-rev__buyer-badge-wrapper').remove();
     secondelement1.after(verifybadge); 
        review_count++;
      }
   });
  }
  $(".jdgm-rev__source img").each(function(){
    var dataVall = $(this).attr("data-src");
      $(this).attr("src", dataVall);
  });
  clearInterval(dateTimeJudge);
}
$("body").on("click",'.jdgm-paginate .jdgm-btn , jdgm-paginate .jdgm-paginate__page',function(e){
  e.preventDefault(); 
    // Call the function directly on button click
  dateTimeJudge = setInterval(rev__timestampFunc, 2000);
});
 $("body").on("click",'.jdgm-all-reviews-page__load-more-wrapper',function(e){
  e.preventDefault(); 
    // Call the function directly on button click
  dateTimeJudge = setInterval(rev__timestampFunc, 2000);
}); 
  if($(".jdgm-all-reviews__summary-stars").length > 0){
    //Review Page total count
var reviewbadge= $(".jdgm-all-reviews__summary-stars").html();
var numberOfReviews = $(".jdgm-all-reviews__header").attr("data-number-of-reviews");
    var totalRating = $(".review_badge").attr("id");
// Convert numberOfReviews to a string and format it as "20,32"
 var formattedReviews = numberOfReviews.toString().slice(0, 1) + ',' + numberOfReviews.toString().slice(1);
   // var formattedReviews = numberOfReviews.toLocaleString();
$(".review_badge").append(totalRating + reviewbadge +"(" +formattedReviews +" "+"review" + ")" ); 
$(".total_review").append("(" +formattedReviews +")" ); 
//end 29july
  }


  /********** feature hover tooltip dekstop ******************/
    $('.feature_hover_content').hover(function(){    
      $('.featured_content_desktop').toggleClass('acive');
    });

  /********** feature hover tooltip mobile ******************/
    $('.featured_text.mobile_text').click(function(){
      $('#tooltip-mobile').toggleClass('acive');
   });
  //Blog Page js
   var blog_id=$('.custom_featured_blog').attr('custom_blog_url');
       $('.custom_grid').each(function(index, element) {
    // Inside this function, 'this' refers to each individual '.custom_grid' element
    $(element).find('.custom_grid_item').each(function() {
        var all_blog_id = $(this).attr('all_blog_handle');
        if(blog_id == all_blog_id){
         $(this).remove();
        }
    });
});

//   Pagination of Donation Page
(function($) {
	var pagify = {
		items: {},
		custom_container: null,
		totalPages: 1,
		perPage: 3,
		currentPage: 0,
		createNavigation: function() {
			this.totalPages = Math.ceil(this.items.length / this.perPage);

			$('.pagination', this.custom_container.parent()).remove();
			var pagination = $('<div class="pagination"></div>').append('<a class="nav prev disabled" data-next="false"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewbox="0 0 11 18" height="18" width="11"><path fill="#4A4A49" d="M0.595984 1.09549C1.38998 0.301503 2.67729 0.301503 3.47128 1.09549L9.92208 7.54625C10.7161 8.34023 10.7161 9.62754 9.92208 10.4215L3.47128 16.8723C2.67729 17.6663 1.38998 17.6663 0.595984 16.8723C-0.198008 16.0783 -0.198008 14.791 0.595984 13.997L5.60914 8.98389L0.595984 3.97077C-0.198008 3.17678 -0.198008 1.88948 0.595984 1.09549Z" clip-rule="evenodd" fill-rule="evenodd"></path></svg></a>');

			for (var i = 0; i < this.totalPages; i++) {
				var pageElClass = "page heading-size-8";
				if (!i)
					pageElClass = "page current heading-size-8";
				var pageEl = '<a class="' + pageElClass + '" data-page="' + (
				i + 1) + '">' + (
				i + 1) + "</a>";
				pagination.append(pageEl);
			}
			pagination.append('<a class="nav next" data-next="true"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewbox="0 0 11 18" height="18" width="11"><path fill="#4A4A49" d="M0.595984 1.09549C1.38998 0.301503 2.67729 0.301503 3.47128 1.09549L9.92208 7.54625C10.7161 8.34023 10.7161 9.62754 9.92208 10.4215L3.47128 16.8723C2.67729 17.6663 1.38998 17.6663 0.595984 16.8723C-0.198008 16.0783 -0.198008 14.791 0.595984 13.997L5.60914 8.98389L0.595984 3.97077C-0.198008 3.17678 -0.198008 1.88948 0.595984 1.09549Z" clip-rule="evenodd" fill-rule="evenodd"></path></svg></a>');

			this.custom_container.after(pagination);

			var that = this;
			$("body").off("click", ".nav");
			this.navigator = $("body").on("click", ".nav", function() {
				var el = $(this);
				that.navigate(el.data("next"));
			});

			$("body").off("click", ".page");
			this.pageNavigator = $("body").on("click", ".page", function() {
				var el = $(this);
				that.goToPage(el.data("page"));
              window.scrollTo({
              top: 350,
              behavior: 'smooth' 
            });
			});
           
		},
		navigate: function(next) {
			// default perPage to 5
			if (isNaN(next) || next === undefined) {
				next = true;
			}
			$(".pagination .nav").removeClass("disabled");
			if (next) {
				this.currentPage++;
				if (this.currentPage > (this.totalPages - 1))
					this.currentPage = (this.totalPages - 1);
				if (this.currentPage == (this.totalPages - 1))
					$(".pagination .nav.next").addClass("disabled");
				}
			else {
				this.currentPage--;
				if (this.currentPage < 0)
					this.currentPage = 0;
				if (this.currentPage == 0)
					$(".pagination .nav.prev").addClass("disabled");
				}

			this.showItems();
          window.scrollTo({
              top: 350,
              behavior: 'smooth' 
            });
		},
		updateNavigation: function() {

			var pages = $(".pagination .page");
			pages.removeClass("current");
			$('.pagination .page[data-page="' + (
			this.currentPage + 1) + '"]').addClass("current");
		},
		goToPage: function(page) {

			this.currentPage = page - 1;

			$(".pagination .nav").removeClass("disabled");
			if (this.currentPage == (this.totalPages - 1))
				$(".pagination .nav.next").addClass("disabled");

			if (this.currentPage == 0)
				$(".pagination .nav.prev").addClass("disabled");
			this.showItems();
		},
		// showItems: function() {
		// 	this.items.hide();
		// 	var base = this.perPage * this.currentPage;
		// 	this.items.slice(base, base + this.perPage).show();

		// 	this.updateNavigation();
		// },
      showItems: function() {
        var pagination_count = parseInt($('.count').attr('donation_block_count'), 10);
    this.perPage = pagination_count;
    this.items.hide();
    var base = this.perPage * this.currentPage;
    this.items.slice(base, base + this.perPage).show();
    this.updateNavigation();
},
		init: function(custom_container, items, perPage) {
			this.custom_container = custom_container;
			this.currentPage = 0;
			this.totalPages = 1;
			this.perPage = perPage;
			this.items = items;
			this.createNavigation();
			this.showItems();
		}
	};

	// stuff it all into a jQuery method!
	$.fn.pagify = function(perPage, itemSelector) {
		var el = $(this);
		var items = $(itemSelector, el);

		// default perPage to 5
		if (isNaN(perPage) || perPage === undefined) {
			perPage = 3;
		}

		// don't fire if fewer items than perPage
		if (items.length <= perPage) {
			return true;
		}

		pagify.init(el, items, perPage);
	};
})(jQuery);
   var customwidth= $(document). width();
  if( customwidth < 768 ){
   $(".custom_container").pagify(8, ".single-item"); 
  }else{
   var pagination_count=$('.count').attr('donation_block_count');
   $(".custom_container").pagify(pagination_count, ".single-item");
  }
window.addEventListener("resize", (event) => {
     var customwidth= $(document). width();
  if( customwidth < 768 ){
   $(".custom_container").pagify(8, ".single-item"); 
  }else{
   var pagination_count=$('.count').attr('donation_block_count');
   $(".custom_container").pagify(pagination_count, ".single-item");
  }
});
  

  
  /************************* Cart drawer start *************************/
   // Extended Warranty popup
    $(".tooltip_icon_img").click(function(){
      $(".tooltip-content-wrapper").addClass("active");
       $("body").addClass("cart-popup-overlay");
    });
    $(".cross-icon").click(function(){
        $(".tooltip-content-wrapper").removeClass("active");
      $("body").removeClass("cart-popup-overlay");
    });
   $('.tooltip-content-wrapper').click(function(e) {
    if(!$('.cross-icon').is(e.target)){
      $('.tooltip-content-wrapper').removeClass('active');
      }
    });
  /************************* Cart drawer end *************************/

/***************** first video play on homepage image-with-video section Start *****************/
//   $(document).ready(function() {
//     function clickvedio(){
//       var winwidth = $(window).width();
//       if(winwidth > 768){
//           var hasClicked = false;
//         $(window).scroll(function() {
//             if (!hasClicked && $(this).scrollTop() > 200) { 
//                 $('#video-section-one').click(); 
//                 hasClicked = true; 
//             }
//         });
//      }
//     }
//     clickvedio();
//      $(window).resize(function(){
//        clickvedio();
//      });
// });
/***************** first video play on homepage image-with-video section End *****************/

  /**************  instagram_feed equal height start *******************/
  setTimeout(function(){
    if( $('.custom-social-media-icon .instafeed_card_info').length > 0){
      var heights = [];
  
      // Get all elements and push their heights to the array
      $('.custom-social-media-icon .instafeed_card_info').each(function() {
          heights.push($(this).height());
      });
  
      // Find the maximum height from the array
      var maxHeight = Math.max.apply(null, heights);
      
      // Set the maximum height to all elements
      $('.custom-social-media-icon .instafeed_card_info').css('height', maxHeight);
    }
  },100);
  $(window).resize(function(){
    setTimeout(function(){
    if( $('.custom-social-media-icon .instafeed_card_info').length > 0){
      var heights = [];
  
      // Get all elements and push their heights to the array
      $('.custom-social-media-icon .instafeed_card_info').each(function() {
          heights.push($(this).height());
      });
  
      // Find the maximum height from the array
      var maxHeight = Math.max.apply(null, heights);
      
      // Set the maximum height to all elements
      $('.custom-social-media-icon .instafeed_card_info').css('height', maxHeight);
    }
  },1000);
  });
  /**************  instagram_feed equal height end *******************/
//   $(".inner-wrapper-text .show-more").each(function(){
//     $(this).click(function(){
//         var html = $(".hidden-data-full-jtpl").html();
//         $(this).parent(".inner-wrapper-text").html(html);
        
//     });
// });
// $(".inner-wrapper-text .show-less").each(function(){
//     $(this).click(function(){
//         var html = $(".hidden-data-less-jtpl").html();
//         $(this).parent(".inner-wrapper-text").html(html);
        
//     });
// });

  // // Active the class
  // $('.inner-image-with-text-wrapper').on('click', function() {
  //    let handle = $(this).find('.text-image-rapper').data('handle');
  //    console.log('Handle:', handle);
    
   
  // });
if($("body").hasClass("template-index")){
  if (window.innerWidth <= 768) {
      var startX, startY;
      var isVerticalScroll;

    var carousel = document.querySelector('.custom-product-slider-jtpl .flickity-slider');
      carousel.addEventListener('touchstart', function(e) {
        startX = e.touches[0].pageX;
        startY = e.touches[0].pageY;
        isVerticalScroll = null;
      }, { passive: true });

    carousel.addEventListener('touchmove', function(e) {
      var dx = Math.abs(e.touches[0].pageX - startX);
      var dy = Math.abs(e.touches[0].pageY - startY);
      if (isVerticalScroll === null) {
        isVerticalScroll = dy > dx;
      }
      if (isVerticalScroll) {
        e.stopPropagation();
      }
    }, { passive: false });
  }
}
});
// Bundle checkout functionality
